enum OverallJobFitScores {
  NO_RESULTS = -1,
  LOW = 0,
  MODERATE = 1,
  MODERATE_HIGH = 2,
  HIGH = 3,
}

export default OverallJobFitScores
